/*
* Copyright (C) GMS Inc - All Rights Reserved
* This file is part of GMSCloud. - Proprietary and confidential
* Unauthorized copying of this file, via any medium is strictly prohibited
* 
* Created on   : 
* @author      : Kanimozhi.S
* @since       : 0.0.1
* Requirement# :
* Purpose      : Features Service
* -----------------------------------------------------------------------------
* Revision History
* -----------------------------------------------------------------------------
* Requirement/
* Issue/WorkItem |   DATE        |   AUTHOR     |   DESCRIPTION OF CHANGE
* -----------------------------------------------------------------------------
* 4037           |  01-04-2025   |   Kanimozhi  | List the Third party service and , new service  configuration API integration 
*
*
*/
import { executeGetData, executePostData, executePutData } from "./ApiBase";
import { ConfigUrl } from "../auth/OidcConfig";


// Features Service api intergaration

export const getAllServices = async (accessToken: any) => {
  const url = `${ConfigUrl.baseURL}/service/getAllService`;
  return await executeGetData(url, accessToken);
};

export const createService= async (payload: any, accessToken: any) => {
    const url = `${ConfigUrl.baseURL}/service/addService`;
    return await executePostData(url, payload, accessToken);
  };

// Features Service Configuration api intergaration
  export const getByServicesConfiguration = async (accessToken: any,serviceId:any) => {
    const url = `${ConfigUrl.baseURL}/serviceConfiguration/config/${serviceId}`;
    return await executeGetData(url, accessToken);
  };

  export const createServiceServicesConfiguration= async (payload: any, accessToken: any) => {
    console.log(payload);
    const url = `${ConfigUrl.baseURL}/serviceConfiguration/addServiceConfiguration`;
    return await executePutData(url, payload, accessToken);
  };

  export const updateMasterSwitch= async (payload: any, accessToken: any) => {
    console.log(payload);
    const url = `${ConfigUrl.baseURL}/service/updateStatus`;
    return await executePutData(url, payload, accessToken);
  };


  export const updateSubscriber= async (payload: any, accessToken: any) => {
    console.log(payload);
    const url = `${ConfigUrl.baseURL}/subscriber/updateSubscriber`;
    return await executePutData(url, payload, accessToken);
  };

  export const getSubscriberById = async (accessToken: any,subscriberId:any) => {
    const url = `${ConfigUrl.baseURL}/subscriber/getSubscriber/${subscriberId}`;
    return await executeGetData(url, accessToken);
  };